import React from 'react';
import './styles.scss'
import classNames from "classnames";

interface ISkeletonProps {
    className: string;
}

const Skeleton = (props: ISkeletonProps) => {

    const {
        className
    } = props;

    const cn = classNames('skeleton', className)

    return (
        <div className={cn} />
    )
}

export default Skeleton
